import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-design-resources',
  templateUrl: './design-resources.component.html',
  styleUrls: ['./design-resources.component.sass']
})
export class DesignResourcesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
